export enum AppClaims {
  AppRolesClaim = 'Adviser Hub:Roles',
  AppExternalRefClaim = 'Adviser Hub:ExternalReference',
}

export enum AppRoles {
  DefaultAdviser = 'Adviser',
  InsuranceAdviser = 'Insurance',
  InvestmentAdviser = 'Investment',
}
